/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_Label_DigitInputs */

const nl_validation_password_label_digit = /** @type {(inputs: Validation_Password_Label_DigitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een cijfer`)
};

/**

* @param {Validation_Password_Label_DigitInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_label_digit = /** @type {((inputs?: Validation_Password_Label_DigitInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_Label_DigitInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_label_digit(inputs)
});
export { validation_password_label_digit as "validation.password.label_digit" }